    <template>
  <div class="container" ref="bayesianComponent">
    <loading-component v-if="isLoading" />
    <no-result-component
      v-else-if="computedContestants == null || computedContestants.length <= 0"
    />
    <div v-else>
        <h2>{{ competition.name }}</h2>
        <section class="section inner-section">
            <div class="container" style="max-width:420px !important;">
                <div class="sticky-tabs">
                    <div class="login-button-wrapper" v-if="isCompetitionCurrent">
                        <button class="button is-primary" @click="login">
                            <span>{{ getLoginButtonText() }}</span>
                        </button>
                    </div>
                    <div class="search-container">
                        <div class="field has-addons is-pulled-right" style="margin-bottom: 10px;">
                            <div class="control">
                                <input class="input"
                                       type="number"
                                       v-model="searchQuery"
                                       placeholder="Brew number"
                                       @keyup.enter="searchBrew">
                            </div>
                            <div class="control">
                                <button class="button is-primary" @click="searchBrew">
                                    <span class="icon">
                                        <b-icon icon="magnify"></b-icon>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="tabs is-centered is-boxed">
                        <ul>
                            <li v-for="class_ in visibleClasses"
                                :key="class_.id"
                                :class="{ 'is-active': selectedClass === class_.id }">
                                <a @click="selectTab(class_.id)">
                                    <span class="tabTitle">
                                        <span class="icon" v-if="class_.name === 'Theme'">
                                            <b-icon icon="trophy" custom-size="mdi-18px"></b-icon>
                                        </span>
                                        <span class="icon" v-if="class_.name === 'Open'">
                                            <b-icon icon="earth" custom-size="mdi-18px"></b-icon>
                                        </span>
                                        <span>{{ class_.name }}</span>
                                    </span>
                                </a>
                            </li>
                            <li :class="{ 'is-active': selectedClass === 'label' }">
                                <a @click="selectTab('label')">
                                    <span class="tabTitle">
                                        <span class="icon">
                                            <b-icon icon="label" custom-size="mdi-18px"></b-icon>
                                        </span>
                                        <span>Label</span>
                                    </span>
                                </a>
                            </li>
                            <li :class="{ 'is-active': selectedClass === 'noclass' }">
                                <a @click="selectTab('noclass')">
                                    <span class="tabTitle">
                                        <span class="icon">No Class</span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="control is-flex is-align-items-center is-justify-content-space-between" style="margin-bottom:15px;">
                        <b-dropdown v-model="sortBy" @change="handleSortChange" aria-role="list" :class="{ 'invisible': selectedClass === 'label' }">
                        <button class="button is-primary" type="button" slot="trigger">
                            <template v-if="sortBy === BeerListSortOrderType.brewName">
                                <b-icon icon="beer"></b-icon>
                                <span>Sort by brew name</span>
                            </template>
                            <template v-else-if="sortBy === BeerListSortOrderType.brewNumber">
                                <b-icon icon="numeric"></b-icon>
                                <span>Sort by brew number</span>
                            </template>
                            <template v-else-if="sortBy === BeerListSortOrderType.brewer">
                                <b-icon icon="account-outline"></b-icon>
                                <span>Sort by brewer</span>
                            </template>
                            <template v-else-if="sortBy === BeerListSortOrderType.myVotes">
                                <b-icon icon="star"></b-icon>
                                <span>Sort by my votes</span>
                            </template>
                            <template v-else-if="sortBy === BeerListSortOrderType.abv">
                                <b-icon icon="percent"></b-icon>
                                <span>Sort by alcohol</span>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item :value="BeerListSortOrderType.brewName" aria-role="listitem">
                            <div class="media">
                                <b-icon class="media-left" icon="beer"></b-icon>
                                <div class="media-content">
                                    <h3>Sort by brew name</h3>
                                </div>
                            </div>
                        </b-dropdown-item>

                        <b-dropdown-item :value="BeerListSortOrderType.brewer" aria-role="listitem">
                            <div class="media">
                                <b-icon class="media-left" icon="account-outline"></b-icon>
                                <div class="media-content">
                                    <h3>Sort by brewer</h3>
                                </div>
                            </div>
                        </b-dropdown-item>

                        <b-dropdown-item :value="BeerListSortOrderType.brewNumber" aria-role="listitem">
                            <div class="media">
                                <b-icon class="media-left" icon="numeric"></b-icon>
                                <div class="media-content">
                                    <h3>Sort by brew number</h3>
                                </div>
                            </div>
                        </b-dropdown-item>

                        <b-dropdown-item :value="BeerListSortOrderType.myVotes" aria-role="listitem">
                            <div class="media">
                                <b-icon class="media-left" icon="star"></b-icon>
                                <div class="media-content">
                                    <h3>Sort by my votes</h3>
                                </div>
                            </div>
                        </b-dropdown-item>

                        <b-dropdown-item :value="BeerListSortOrderType.abv" aria-role="listitem">
                            <div class="media">
                                <b-icon class="media-left" icon="percent"></b-icon>
                                <div class="media-content">
                                    <h3>Sort by alcohol</h3>
                                </div>
                            </div>
                        </b-dropdown-item>
                    </b-dropdown>

                        <div class="is-flex is-align-items-center ml-auto" v-if="isLoggedIn">
                            <b-switch v-model="showUnvotedOnly"
                                      :class="{ 'invisible': selectedClass === 'label' || selectedClass === 'noclass', 'unvoted-switch': true }"
                                      :rounded="false">
                                Unvoted
                            </b-switch>
                        </div>
                    </div>
                </div>

                <div v-if="selectedClass === 'label'" class="label-competition">
                    <!-- Information text -->
                    <div class="label-info-well">
                        <b-icon icon="information-outline" size="is-small"></b-icon>
                        <span>Vote for your favorite label. You can only vote for one. Labels marked with (AI) are AI-generated.</span>
                    </div>
                    
                    <!-- Top Section with Current Vote -->
                    <div class="label-controls-section">
                        <!-- Current Label Vote Display -->
                        <div v-if="labelVote" class="current-vote-section">
                            <p class="mb-2"><strong>Your current vote:</strong></p>
                            <div class="selected-label-card">
                                <div class="label-vote-info">
                                    <p class="label-title-ellipsis"><strong>{{labelVote.title}}</strong></p>
                                    <p class="is-size-7 label-brewer-ellipsis">{{labelVote.brewer}}</p>
                                </div>
                                <div class="vote-actions-row">
                                    <button class="button is-small"
                                            @click="deleteLabelVote">
                                        <span class="icon">
                                            <b-icon icon="delete" size="is-small"></b-icon>
                                        </span>
                                        <span>Remove vote</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Label List -->
                    <div class="label-list">
                        <div v-for="brew in shuffledLabelBrews" :key="brew.id" 
                             class="brew-card clearfix"
                             :class="{ 'voted-label-card': labelVote && labelVote.id === brew.id }">
                            <div class="brew-card-header row clearfix">
                                <div class="alignleft">
                                    <div class="brew-card-header-title">
                                        <p class="brew-title-container">
                                            <span class="brew-title-text label-title-ellipsis"><strong>{{brew.title}}</strong></span>
                                        </p>
                                    </div>
                                </div>
                                <div class="alignright">
                                    <div class="brew-card-header-class competition-class-purple">
                                        <p style="line-height: 34px; margin: 0;">&nbsp;Label</p>
                                    </div>
                                </div>
                            </div>

                            <div class="brew-card-body">
                                <div class="row clearfix">
                                    <div class="alignleft">
                                        <p class="label-brewer-ellipsis">{{brew.brewer}}</p>
                                    </div>
                                </div>
                                <!-- Vote Section -->
                                <div class="label-vote-section">
                                    <div v-if="labelVote && labelVote.id === brew.id" class="voted-indicator">
                                        <span class="icon has-text-success">
                                            <b-icon icon="check-circle" size="is-small"></b-icon>
                                        </span>
                                        <span class="has-text-success"><strong>Your vote</strong></span>
                                    </div>
                                    <div v-else-if="isLoggedIn && isCompetitionCurrent" class="vote-button-container">
                                        <button class="button is-small vote-button"
                                                @click="voteLabelBrew(brew)">
                                            <span class="icon">
                                                <b-icon icon="star" size="is-small"></b-icon>
                                            </span>
                                            <span>Vote</span>
                                        </button>
                                    </div>
                                    <div v-else-if="!isLoggedIn && isCompetitionCurrent" class="vote-button-container">
                                        <button class="button is-small vote-button"
                                                @click="showLoginRequiredDialog">
                                            <span class="icon">
                                                <b-icon icon="star" size="is-small"></b-icon>
                                            </span>
                                            <span>Vote</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else v-for="brew in filteredContestants" :key="brew.id">
                    <div class="brew-card-container"
                         :class="{ 'fade-out': fadingBrews.has(brew.id) }">
                        <div class="brew-card clearfix" :data-brew-number="brew.displayNumber">
                            <div class="brew-card-header row clearfix">
                                <div class="alignleft">
                                    <div class="brew-card-header-title">
                                        <p class="brew-title-container">
                                            <span class="brew-number">{{brew.displayNumber}}</span>
                                            <span class="brew-title-text"><strong>{{brew.title}}</strong></span>
                                            <brew-vote-display v-if="votes[brew.id]" :value="votes[brew.id]" />
                                        </p>
                                    </div>
                                </div>
                                <div class="alignright">
                                    <div class="brew-card-header-class"
                                         :class="getClassClass(brew.competitionClassId)">
                                        <p>&nbsp;{{getClassLabel(brew.competitionClassId)}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="brew-card-body">
                                <div class="row clearfix">
                                    <div class="alignleft">
                                        <p>{{brew.brewer}}</p>
                                    </div>
                                    <div class="alignright">
                                        <p style="text-align:right;">&nbsp;</p>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="alignleft">
                                        <p>
                                            <i>{{brew.style}}</i>
                                        </p>
                                    </div>
                                    <div class="alignright">
                                        <p>
                                            <i>{{brew.abv}}%</i>
                                        </p>
                                    </div>
                                </div>
                                <div v-if="canVoteOnBrew(brew.competitionClassId)">
                                    <brew-vote-interface v-if="isLoggedIn"
                                                         :value="votes[brew.id]"
                                                         @save="(value, callback) => handleVoteSave(brew.id, value, callback)"
                                                         @delete="(callback) => handleVoteDelete(brew.id, callback)"
                                                         @edit="() => openVoteDialog(brew)" />
                                    <div v-else class="vote-interface">
                                        <div class="vote-actions-container justify-end">
                                            <button class="button is-small vote-button" @click="showLoginRequiredDialog">
                                                <span class="icon">
                                                    <b-icon icon="star" size="is-small"></b-icon>
                                                </span>
                                                <span>Vote</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div v-if="isLoggedIn && isBrewer && brewersChoiceEnabled" class="brewers-choice-toggle">
                                        <b-button size="is-small"
                                                  :icon-left="brew.id === brewersChoiceBrewId ? 'trophy' : 'trophy-outline'"
                                                  :class="brew.id === brewersChoiceBrewId ? 'is-warning' : 'is-outlined'"
                                                  @click="handleBrewersChoiceToggle(brew)">
                                            {{ brew.id === brewersChoiceBrewId ? "Your brewer's choice" : "Set as brewer's choice" }}
                                        </b-button>
                                        <b-tooltip label="As a brewer, you can pick one brew as the best of the event."
                                                   position="is-left"
                                                   multilined>
                                            <b-icon icon="information-outline" size="is-small"></b-icon>
                                        </b-tooltip>
                                    </div>
                                </div>
                            </div>

                            <div class="brew-card-footer row clearfix"
                                 v-on:click="brew.description || brew.ingredients ? brew.isUnfolded = !brew.isUnfolded : null"
                                 :class="{ 'disabled': !brew.description && !brew.ingredients }">
                                <span v-if="brew.isUnfolded"
                                      :class="{'text-disabled': !brew.description && !brew.ingredients }"
                                      class="mdi mdi-unfold-less-horizontal"></span>
                                <span v-else
                                      :class="{'text-disabled': !brew.description && !brew.ingredients }"
                                      class="mdi mdi-unfold-more-horizontal"></span>
                                <div class="brew-card-footer-extra-info row clearfix"
                                     v-bind:class="{active:!brew.isUnfolded}">
                                    <div v-if="brew.description">
                                        <p>
                                            <strong>Description</strong>
                                        </p>
                                        <p>{{brew.description}}</p>
                                    </div>
                                    <div v-if="brew.ingredients" style="margin-top:5px">
                                        <p></p>
                                        <p>
                                            <strong>Ingredients</strong>
                                        </p>
                                        <p>{{brew.ingredients}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  </div>
</template>


<script>
import LoadingComponent from "./Loading.vue";
import NoResultComponent from "./NoResult.vue";
import BeerListSortOrderType from "../enums/beerListSortOrderType.js";
import CompetitionClassType from "../enums/competitionClassType.js";
import BrewVoteDisplay from "./BrewVoteDisplay.vue";
import BrewVoteInterface from "./BrewVoteInterface.vue";
import { Dialog } from "buefy";
import seedrandom from "seedrandom";

import apiService from "./../services/apiService";
export default {
  name: "bayesian-competition",
  components: {
    LoadingComponent,
    NoResultComponent,
    BrewVoteDisplay,
    BrewVoteInterface,
  },
  props: {
      competitionId: String,
      brewId: String
  },

  data() {
    return {
      isLoading: false,
      contestants: [],
      competition: null,
      BeerListSortOrderType: BeerListSortOrderType,
      sortBy: BeerListSortOrderType.brewName,
      selectedClass: null,
      searchQuery: "",
      isLoggedIn: false,
      votes: {},
      showPassword: false,
      keyword: '',
      voteKey: '',
      labelVote: null,
      showUnvotedOnly: false,
      fadingBrews: new Set(),
      isCompetitionCurrent: false,
      isVoteDialogOpen: false,
      isBrewer: false,
      brewersChoiceBrewId: null,
    };
  },
  async created() {
    this.isLoading = true;
    try {
        await this.fetch();
        const themeClass = this.competition.classes.find(c => c.name === 'Theme');
        if (themeClass) {
            this.selectedClass = themeClass.id;
        }

        this.isCompetitionCurrent = this.competition.isCurrent;

        // Don't login if competition is not current
        if (this.isCompetitionCurrent) {
            var keywordLocalStorage = this.getKeyWordLocalStorage();
            var voteKeyLocalStorage = this.getVoteKeyLocalStorage();

            if (keywordLocalStorage && voteKeyLocalStorage) {
                this.keyword = keywordLocalStorage;
                this.voteKey = voteKeyLocalStorage;
                this.isLoggedIn = true;
                this.isBrewer = this.getIsBrewerLocalStorage();
            }

            if (this.isLoggedIn) {
                await this.loadVotesFromApi();
                await this.loadLabelVoteFromApi();
                if (this.isBrewer && this.brewersChoiceEnabled) {
                    await this.loadBrewersChoiceVoteFromApi();
                }
            }
        }
        
        this.loadSortPreference();

        if (this.brewId) {
            this.searchQuery = this.brewId;
            this.$nextTick(() => {
                this.searchBrew();
            });
        }
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    handleSortChange(newValue) {
        this.saveSortPreference(newValue);
    },
    saveSortPreference(sortValue) {
        const key = `bosspour_sortPreference_${this.competitionId}`;
        localStorage.setItem(key, sortValue);
    },
    loadSortPreference() {
        const key = `bosspour_sortPreference_${this.competitionId}`;
        const savedSort = localStorage.getItem(key);

        if (savedSort && Object.values(this.BeerListSortOrderType).map(String).includes(savedSort)) {
            const enumKey = Object.keys(this.BeerListSortOrderType)
                .find(key => String(this.BeerListSortOrderType[key]) === savedSort);

            this.sortBy = this.BeerListSortOrderType[enumKey];
        } else {
            this.sortBy = this.BeerListSortOrderType.brewName;
        }
    },
    searchBrew() {
        if (!this.searchQuery) return;

        const foundBrew = this.contestants.find(brew =>
            brew.displayNumber.toString() === this.searchQuery
        );

        if (foundBrew) {
            const brewClass = this.competition.classes.find(c => c.id === foundBrew.competitionClassId);
            // If the brew is in a single vote class, don't scroll to it
            if (brewClass && brewClass.competitionClassType !== CompetitionClassType.bayesianVote) {
                return false;
            }

            // Check if brew would be filtered out by unvoted filter
            const isBrewVoted = this.votes[foundBrew.id] !== undefined;
            const wouldBeFilteredOut = this.showUnvotedOnly && this.isLoggedIn && isBrewVoted;

            if (wouldBeFilteredOut) {
                // Ask user if they want to turn off the unvoted filter
                this.$dialog.confirm({
                    title: 'Show voted brew',
                    message: `Brew ${this.searchQuery} exists but is hidden because you've already voted on it. Do you want to turn off the "Unvoted" filter to see it?`,
                    confirmText: 'Yes, show it',
                    cancelText: 'Cancel',
                    type: 'is-info',
                    hasIcon: true,
                    onConfirm: () => {
                        // Turn off the unvoted filter
                        this.showUnvotedOnly = false;
                        // Wait for DOM to update after filter change before scrolling
                        this.$nextTick(() => {
                            setTimeout(() => {
                                // Continue with the normal search behavior
                                this.performBrewSearch(foundBrew, brewClass);
                            }, 500);
                        });
                    }
                });
                return;
            }

            // Normal search behavior
            this.performBrewSearch(foundBrew, brewClass);
        } else {
            // Brew not found
            this.$toast.open({
                message: `Brew ${this.searchQuery} not found`,
                type: 'is-warning',
                position: 'is-bottom'
            });
        }
    },
    performBrewSearch(foundBrew, brewClass) {
        // First select the correct class tab
        this.selectedClass = brewClass ? foundBrew.competitionClassId : 'noclass';

        // Remove focus from the search input/button. When the search button is
        // clicked it receives focus, and Chrome scrolls the focused element back
        // into view, which cancels the smooth scroll below.
        if (document.activeElement) {
            document.activeElement.blur();
        }

        // Wait for the DOM to update and the browser to paint after tab change
        this.$nextTick(() => {
            setTimeout(() => {
                // Get the brew element using the displayNumber of the found brew
                const searchNumber = foundBrew.displayNumber;
                const brewElement = document.querySelector(`[data-brew-number="${searchNumber}"]`);

                if (brewElement) {
                    // Calculate header height
                    const headerHeight = document.querySelector('.sticky-tabs').getBoundingClientRect().height;

                    // Scroll the element to top
                    window.scrollTo({
                        top: brewElement.offsetTop - headerHeight + 82,
                        behavior: 'smooth'
                    });

                    this.searchQuery = '';
                }
            }, 100);
        });
    },
    getClassLabel(classId) {
        var self = this;
        var c = this.competition.classes.find(function(element) {
            return element.id == classId;
        });
        if (c) {
            return c.name;
        } else return "No class";
    },
    getClassClass(classId) {
        var self = this;
        var c = this.competition.classes.find(function(element) {
        return element.id == classId;
        });
        if (c) {
        return c.cssClass;
        } else return "competition-class-black  tag";
    },
    async fetch() {
        const brewData = await apiService.getBrewsForCompetition(
        this.competitionId
        );

        brewData.data.forEach(function(c) {
        c.isUnfolded = false;
        });
        this.contestants = brewData.data;
        const competitionData = await apiService.getCompetition(
        this.competitionId
        );

        this.competition = competitionData.data;
    },
    toggle(row) {
        this.$refs.table.toggleDetails(row);
    },
    showLoginRequiredDialog() {
        this.$dialog.alert({
            title: 'Login Required',
            message: 'You need to be logged in to vote in this competition. To log in, you first need to reserve a keyword. Please check your email for instructions.',
            confirmText: 'OK',
            type: 'is-info',
        });
    },
    // Shuffle array with seed using seedrandom
    shuffleArrayWithSeed(array, seed) {
        // Create a seeded random number generator
        const rng = seedrandom(seed);
        
        // Create a copy of the array
        const shuffled = [...array];
        
        // Fisher-Yates shuffle with seeded random
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(rng() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        
        return shuffled;
    },
    async voteLabelBrew(brew) {
        // If already have a vote for a different brew, show confirmation
        if (this.labelVote && this.labelVote.id !== brew.id) {
            this.$dialog.confirm({
                title: 'Change vote',
                message: `You have already voted for "${this.labelVote.title}". Do you want to change your vote to "${brew.title}"?`,
                confirmText: 'Yes, change vote',
                cancelText: 'Cancel',
                type: 'is-warning',
                hasIcon: true,
                onConfirm: async () => {
                    await this.saveLabelVoteForBrew(brew);
                }
            });
        } else {
            await this.saveLabelVoteForBrew(brew);
        }
    },
    async saveLabelVoteForBrew(brew) {
        try {
            const foundBrew = this.contestants.find(b => b.id === brew.id);
            
            if (foundBrew) {
                const brewClass = this.competition.classes.find(c => c.id === foundBrew.competitionClassId);
                
                if (brewClass && brewClass.competitionClassType !== CompetitionClassType.singleVote) {
                    console.error("Brew class not found");
                    this.$dialog.alert({
                        title: 'Error',
                        message: 'Failed to find brew class. Please try again.',
                        type: 'is-danger',
                    });
                    return;
                }
                
                const payload = {
                    singleVoteModel: {
                        brewId: brew.id,
                        competitionId: this.competitionId,
                        competitionClassId: foundBrew.competitionClassId,
                        keyword: this.keyword
                    },
                    voteKey: this.voteKey
                };
                
                await apiService.addSingleVote(payload);
                
                this.labelVote = {
                    id: brew.id,
                    title: brew.title,
                    brewer: brew.brewer
                };
                
                this.$toast.open({
                    message: `Vote saved for "${brew.title}"`,
                    type: 'is-success',
                    position: 'is-bottom'
                });
            } else {
                console.error("Brew not found");
                this.$dialog.alert({
                    title: 'Error',
                    message: 'Failed to find brew. Please try again.',
                    type: 'is-danger',
                });
            }
        } catch (error) {
            console.error('Error saving label vote:', error);
            await this.handleVoteError(error);
        }
    },
    sortCompNumberAsc(a, b) {
        if (a > b) return +1;
        if (a < b) return -1;
        return 0;
    },
    sortCompNumberDesc(a, b) {
        if (a > b) return -1;
        if (a < b) return +1;
        return 0;
    },
    sortCompStringAsc(a, b) {
        return a.localeCompare(b, "sv");
    },
    sortCompStringDesc(a, b) {
        return b.localeCompare(a, "sv");
    },
    parseAbv(abvString) {
        if (!abvString) return 0;

        const cleanedValue = abvString.replace('%', '').trim();
        const parsedValue = parseFloat(cleanedValue);

        return isNaN(parsedValue) ? 0 : parsedValue;
    },
    selectTab(classId) {
        this.selectedClass = classId;

        //Scroll to top
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    },
      login() {
          if (this.isLoggedIn) {
              this.keyword = "";
              this.voteKey = "";
              this.labelVote = null;
              this.votes = {};
              this.isLoggedIn = false;
              this.isBrewer = false;
              this.brewersChoiceBrewId = null;
              this.deleteKeywordLocalStorage();
              this.deleteVoteKeyLocalStorage();
              this.deleteIsBrewerLocalStorage();
              return;
          }
          
          const self = this;

          this.$dialog.confirm({
              title: 'Login Required',
              message: `
            <div class="content">
                <p>Please check your email about how to reserve a keyword if you haven't already done so. Reserving a keyword is required to be able to login.</p>
                <div class="field">
                    <div class="control">
                        <input class="input" type="email" placeholder="Email" id="login-email">
                    </div>
                </div>
                <div class="field">
                    <div class="control has-icons-right" style="position: relative;">
                        <input class="input" type="password" placeholder="Keyword" id="login-password">
                        <button type="button" class="icon is-right is-clickable" 
                                style="pointer-events: all; cursor: pointer; background: none; border: none; padding: 0 10px; 
                                       position: absolute; top: 50%; transform: translateY(-50%); right: 0; height: 100%;" 
                                id="password-toggle">
                            <i class="mdi mdi-eye" style="color: #363636;"></i>
                        </button>
                    </div>
                </div>
            </div>
        `,
        confirmText: 'Login',
        cancelText: 'Cancel',
        type: 'is-primary',
        hasIcon: false,
        trapFocus: true,
        onConfirm: async () => {
            if (!this.competitionId) {
                console.error('No competition ID found');
                return;
            }
            const email = document.getElementById('login-email').value.trim().toLowerCase();
            const keyword = document.getElementById('login-password').value.trim().toLowerCase();
            this.keyword = "";
            this.voteKey = "";
            this.labelVote = null;
            this.votes = {};
            this.isBrewer = false;
            this.brewersChoiceBrewId = null;

            const payload = {
                competitionId: this.competitionId,
                email: email,
                keyword: keyword,
            };

            let voteKey;

            try {
                voteKey = await apiService.getVoteKeyByLogin(payload);
            } catch (apiError) {
                console.error('API call failed:', apiError);
                this.$dialog.alert({
                    title: 'Error',
                    message: 'There was a problem logging in. Please try again.',
                    type: 'is-danger',
                });
                return;
            }

            if (voteKey.data && voteKey.data.voteKey) {
                this.keyword = keyword;
                this.voteKey = voteKey.data.voteKey;
                this.isBrewer = voteKey.data.isBrewer === true;
                this.isLoggedIn = true;
                this.setKeyWordLocalStorage(keyword);
                this.setVoteKeyLocalStorage(voteKey.data.voteKey);
                this.setIsBrewerLocalStorage(this.isBrewer);
            } else {
                console.error('No vote key received');
                this.isLoggedIn = false;
            }

            this.isLoggedIn = true;
            await this.loadVotesFromApi();
            await this.loadLabelVoteFromApi();
            if (this.isBrewer && this.brewersChoiceEnabled) {
                await this.loadBrewersChoiceVoteFromApi();
            }
        }});

        setTimeout(() => {
            const toggleBtn = document.getElementById('password-toggle');
            const passwordInput = document.getElementById('login-password');
            const eyeIcon = document.querySelector('#password-toggle i');

            if (toggleBtn && passwordInput && eyeIcon) {
                toggleBtn.onclick = function () {
                    if (passwordInput.type === 'password') {
                        passwordInput.type = 'text';
                        eyeIcon.className = 'mdi mdi-eye-off';
                    } else {
                        passwordInput.type = 'password';
                        eyeIcon.className = 'mdi mdi-eye';
                    }
                };
            }
        }, 100);
    },
    setVoteKeyLocalStorage(voteKey) {
        const voteKeyLocalStorageKey = `bosspour_voteKey_${this.competitionId}`;
        localStorage.setItem(voteKeyLocalStorageKey, voteKey);
    },
    setKeyWordLocalStorage(keyword) {
        const keywordLocalStorageKey = `bosspour_keyword_${this.competitionId}`;
        localStorage.setItem(keywordLocalStorageKey, keyword);
    },
    getVoteKeyLocalStorage() {
        const voteKeyLocalStorageKey = `bosspour_voteKey_${this.competitionId}`;
        return localStorage.getItem(voteKeyLocalStorageKey);
    },
    getKeyWordLocalStorage() {
        const keywordLocalStorageKey = `bosspour_keyword_${this.competitionId}`;
        return localStorage.getItem(keywordLocalStorageKey);
    },
    deleteVoteKeyLocalStorage() {
        const voteKeyLocalStorageKey = `bosspour_voteKey_${this.competitionId}`;
        localStorage.removeItem(voteKeyLocalStorageKey);
    },
    deleteKeywordLocalStorage() {
        const keywordLocalStorageKey = `bosspour_keyword_${this.competitionId}`;
        localStorage.removeItem(keywordLocalStorageKey);
    },
    setIsBrewerLocalStorage(isBrewer) {
        const isBrewerLocalStorageKey = `bosspour_isBrewer_${this.competitionId}`;
        localStorage.setItem(isBrewerLocalStorageKey, isBrewer ? 'true' : 'false');
    },
    getIsBrewerLocalStorage() {
        const isBrewerLocalStorageKey = `bosspour_isBrewer_${this.competitionId}`;
        return localStorage.getItem(isBrewerLocalStorageKey) === 'true';
    },
    deleteIsBrewerLocalStorage() {
        const isBrewerLocalStorageKey = `bosspour_isBrewer_${this.competitionId}`;
        localStorage.removeItem(isBrewerLocalStorageKey);
    },
    getLoginButtonText() {
        return this.isLoggedIn ? 'Log out' : 'Log in';
    },
    scrollToBrewIfNeeded(brewId) {
        const foundBrew = this.contestants.find(brew =>
            brew.id.toString() === brewId
        );

        //Check if sorting is by votes, then I need to search the brew number and scroll to it
        if (this.sortBy === BeerListSortOrderType.myVotes && !this.showUnvotedOnly) {
            this.searchQuery = foundBrew.displayNumber.toString();
            this.$nextTick(() => {
                this.searchBrew();
            });
        }
    },
    canVoteOnBrew(classId) {
        const brewClass = this.competition.classes.find(c => c.id === classId)
        return brewClass && this.isCompetitionCurrent && (brewClass.name === 'Theme' || brewClass.name === 'Open')
    },
    async loadVotesFromApi() {
        try {
            const payload = {
                competitionId: this.competitionId,
                voteKey: this.voteKey,
                keyword: this.keyword
            };

            // Load Bayesian votes
            const bayesianResponse = await apiService.getBayesianVotesByUser(payload);
            if (bayesianResponse.data) {
                this.votes = bayesianResponse.data.reduce((acc, vote) => {
                    acc[vote.brewId] = vote.score;
                    return acc;
                }, {});
            }
        } catch (error) {
            console.error('Error loading votes:', error);
            this.$dialog.alert({
                title: 'Error',
                message: 'Failed to load your votes. Please try again later.',
                type: 'is-danger',
            });
        }
    },
    async loadLabelVoteFromApi() {
        try {
            const payload = {
                competitionId: this.competitionId,
                voteKey: this.voteKey,
                keyword: this.keyword
            };

            // Load single votes (used for label voting)
            const singleResponse = await apiService.getSingleVotesByUser(payload);

            const labelClass = this.competition.classes.find(c => c.name === 'Label');
            if (!labelClass) {
                console.error('Label class not found');
                return;
            }
            if (singleResponse.data && singleResponse.data.length > 0) {
                const labelVoteData = singleResponse.data.find(vote => vote.competitionClassId === labelClass.id);

                const brew = this.contestants.find(c => c.id === labelVoteData.brewId);

                if (!brew) {
                    console.error('Brew not found for label vote:', labelVoteData.brewId);
                    this.$dialog.alert({
                        title: 'Error',
                        message: 'Brew not found for label vote. Please try again.',
                        type: 'is-danger',
                    });
                }

                this.labelVote = {
                    id: labelVoteData.brewId,
                    title: brew ? brew.title : '',
                    brewer: brew ? brew.brewer : ''
                };
            } 
            else {
                this.labelVote = null;
            }
        } catch (error) {
            console.error('Error loading label vote:', error);
            this.$dialog.alert({
                title: 'Error',
                message: 'Error loading label vote. Please try again.',
                type: 'is-danger',
            });
        }
      },
      async loadBrewersChoiceVoteFromApi() {
        try {
            const response = await apiService.getBrewersChoiceVoteByUser({
                competitionId: this.competitionId,
                voteKey: this.voteKey,
                keyword: this.keyword
            });

            this.brewersChoiceBrewId = response.data ? response.data.brewId : null;
        } catch (error) {
            console.error('Error loading brewers choice vote:', error);
        }
      },
      async handleBrewersChoiceSave(foundBrew, brewersChoice) {
        try {
            if (brewersChoice === true && foundBrew.id !== this.brewersChoiceBrewId) {
                await apiService.addBrewersChoiceVote({
                    brewersChoiceVoteModel: {
                        brewId: foundBrew.id,
                        competitionId: this.competitionId,
                        competitionClassId: foundBrew.competitionClassId,
                        keyword: this.keyword
                    },
                    voteKey: this.voteKey
                });
                this.brewersChoiceBrewId = foundBrew.id;
            } else if (brewersChoice === false && foundBrew.id === this.brewersChoiceBrewId) {
                await apiService.deleteBrewersChoiceVote({
                    competitionId: this.competitionId,
                    competitionClassId: foundBrew.competitionClassId,
                    brewId: foundBrew.id,
                    voteKey: this.voteKey,
                    keyword: this.keyword
                });
                this.brewersChoiceBrewId = null;
            }
        } catch (error) {
            console.error('Error saving brewers choice vote:', error);
            this.$toast.open({
                message: error.response && error.response.data ? error.response.data : "Failed to save brewer's choice vote. Please try again.",
                type: "is-danger",
                position: "is-bottom"
            });
        }
      },
      handleBrewersChoiceToggle(brew) {
        if (brew.id === this.brewersChoiceBrewId) {
            this.$dialog.confirm({
                title: "Remove brewer's choice",
                message: "Are you sure you want to remove this brew as your brewer's choice?",
                confirmText: 'Remove',
                cancelText: 'Cancel',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.handleBrewersChoiceSave(brew, false)
            });
            return;
        }

        if (this.brewersChoiceBrewId) {
            const currentChoice = this.contestants.find(b => b.id === this.brewersChoiceBrewId);
            const currentChoiceText = currentChoice ? `brew #${currentChoice.displayNumber}` : 'another brew';
            this.$dialog.confirm({
                title: "Change brewer's choice",
                message: `You have already chosen ${currentChoiceText} as your brewer's choice. Do you want to change it to this brew?`,
                confirmText: 'Change',
                cancelText: 'Cancel',
                type: 'is-warning',
                hasIcon: true,
                onConfirm: () => this.handleBrewersChoiceSave(brew, true)
            });
            return;
        }

        this.$dialog.confirm({
            title: "Set brewer's choice",
            message: "Do you want to set this brew as your brewer's choice?",
            confirmText: "Set as brewer's choice",
            cancelText: 'Cancel',
            type: 'is-info',
            hasIcon: true,
            onConfirm: () => this.handleBrewersChoiceSave(brew, true)
        });
      },
      async handleVoteError(error) {
          console.error('Vote error:', error);

          // Check if the error could be due to competition being closed
          if (error.response && error.response.status === 400) {
              try {
                  const competitionData = await apiService.getCompetition(this.competitionId);

                  // If competition is not current/open, show specific message
                  if (!competitionData.isCurrent || !competitionData.isOpen) {
                      this.$dialog.alert({
                          title: 'Competition Closed',
                          message: 'Voting is no longer available as this competition is closed.',
                          type: 'is-warning',
                      });
                      return;
                  }
              } catch (fetchError) {
                  console.error('Error fetching competition data:', fetchError);
                  // Continue to default error handling if we can't fetch competition
              }
          }

          // Default error handling for other errors
          this.$dialog.alert({
              title: 'Error',
              message: 'Failed to process your vote. Please try again.',
              type: 'is-danger',
          });
    },
    async handleVoteSave(brewId, value, callback) {
        try {
            const foundBrew = this.contestants.find(brew =>
                brew.id === brewId
            );

            if (foundBrew) {
                const brewClass = this.competition.classes.find(c => c.id === foundBrew.competitionClassId);
                if (brewClass && brewClass.competitionClassType !== CompetitionClassType.bayesianVote) {
                    console.error("Brew class not found");
                    this.$dialog.alert({
                        title: 'Error',
                        message: 'Failed to find brew class. Please try again.',
                        type: 'is-danger',
                    });
                    return;
                }

                const payload = {
                    bayesianVoteModel: {
                        brewId: brewId,
                        competitionId: this.competitionId,
                        competitionClassId: foundBrew.competitionClassId,
                        keyword: this.keyword,
                        score: value
                    },
                    voteKey: this.voteKey,
                };

                if (this.showUnvotedOnly) {
                    // Start the fade animation, need to make new Set like this to make UI react.
                    this.fadingBrews = new Set([...this.fadingBrews, brewId]);

                    // Wait for animation to complete before updating votes
                    setTimeout(async () => {
                        try {
                            await apiService.addBayesianVote(payload);
                            this.$set(this.votes, brewId, value);
                            this.scrollToBrewIfNeeded(brewId);
                            this.fadingBrews.delete(brewId);
                            callback(value);
                        }
                        catch (error) {
                            await this.handleVoteError(error);
                        }
                        finally {
                            this.fadingBrews.delete(brewId);
                        }
                    }, 500);
                } else {
                    // If not showing unvoted only, update immediately
                    try {
                        await apiService.addBayesianVote(payload);
                        this.$set(this.votes, brewId, value);
                        this.scrollToBrewIfNeeded(brewId);
                        callback(value);
                    } catch (error) {
                        await this.handleVoteError(error);
                    }
                }
            }
            else {
                console.error("Brew not found");
                this.$dialog.alert({
                    title: 'Error',
                    message: 'Failed to find brew. Please try again.',
                    type: 'is-danger',
                });
            }
        } catch (error) {
            console.error('Error saving vote:', error);
            await this.handleVoteError(error);
        }
    },
    async handleVoteDelete(brewId, callback) {
        try {
            const foundBrew = this.contestants.find(brew =>
                brew.id === brewId
            );

            if (foundBrew) {
                const brewClass = this.competition.classes.find(c => c.id === foundBrew.competitionClassId);
                if (brewClass && brewClass.competitionClassType !== CompetitionClassType.bayesianVote) {
                    console.error("Brew class not found");
                    this.$dialog.alert({
                        title: 'Error',
                        message: 'Failed to find brew class. Please try again.',
                        type: 'is-danger',
                    });
                    return;
                }

                const payload = {
                    brewId: brewId,
                    competitionId: this.competitionId,
                    competitionClassId: foundBrew.competitionClassId,
                    voteKey: this.voteKey,
                    keyword: this.keyword
                };

                try {
                    await apiService.deleteBayesianVote(payload);
                    this.$delete(this.votes, brewId);
                    this.scrollToBrewIfNeeded(brewId);
                    callback();
                } catch (error) {
                    await this.handleVoteError(error);
                }
            }
            else {
                console.error("Brew not found");
                this.$dialog.alert({
                    title: 'Error',
                    message: 'Failed to find brew. Please try again.',
                    type: 'is-danger',
                });
            }
        } catch (error) {
            console.error('Error deleting vote:', error);
            await this.handleVoteError(error);
        }
    },
    openVoteDialog(brew) {
        // Prevent opening multiple dialogs
        if (this.isVoteDialogOpen) {
            return;
        }
        
        const currentVote = this.votes[brew.id] || null;
        const self = this;
        
        this.isVoteDialogOpen = true;
        
        // Use Buefy's modal component
        const modalInstance = this.$modal.open({
            parent: this,
            component: BrewVoteInterface,
            props: {
                value: currentVote,
                isDialogMode: true,
                brew: brew,
                hideButtons: false,
                startInEditMode: true
            },
            hasModalCard: true,
            customClass: 'vote-dialog-modal',
            trapFocus: true,
            events: {
                'save': async (value) => {
                    if (value > 0) {
                        try {
                            // Handle the save directly for modal
                            const foundBrew = self.contestants.find(b => b.id === brew.id);
                            
                            if (foundBrew) {
                                const brewClass = self.competition.classes.find(c => c.id === foundBrew.competitionClassId);
                                if (brewClass && brewClass.competitionClassType !== CompetitionClassType.bayesianVote) {
                                    console.error("Brew class not found");
                                    self.$dialog.alert({
                                        title: 'Error',
                                        message: 'Failed to find brew class. Please try again.',
                                        type: 'is-danger',
                                    });
                                    modalInstance.close();
                                    return;
                                }
                            } else {
                                console.error("Brew not found in contestants");
                                self.$dialog.alert({
                                    title: 'Error',
                                    message: 'Failed to find brew. Please try again.',
                                    type: 'is-danger',
                                });
                                // Keep dialog open so user can try again or cancel
                                return;
                            }
                            
                            if (foundBrew) {

                                const payload = {
                                    bayesianVoteModel: {
                                        brewId: brew.id,
                                        competitionId: self.competitionId,
                                        competitionClassId: foundBrew.competitionClassId,
                                        keyword: self.keyword,
                                        score: value
                                    },
                                    voteKey: self.voteKey,
                                };

                                await apiService.addBayesianVote(payload);
                                
                                // Close the modal first
                                self.isVoteDialogOpen = false;
                                modalInstance.close();
                                
                                // Handle the fade animation and vote update
                                if (self.showUnvotedOnly) {
                                    // Start fade animation immediately
                                    self.fadingBrews = new Set([...self.fadingBrews, brew.id]);
                                    
                                    // Wait for fade animation to complete before updating votes
                                    setTimeout(() => {
                                        self.$set(self.votes, brew.id, value);
                                        self.fadingBrews.delete(brew.id);
                                        self.scrollToBrewIfNeeded(brew.id);
                                    }, 500); // Match the CSS transition duration
                                } else {
                                    // If not filtering, update immediately
                                    self.$set(self.votes, brew.id, value);
                                    self.scrollToBrewIfNeeded(brew.id);
                                }
                            }
                        } catch (error) {
                            console.error('Error saving vote from dialog:', error);
                            await self.handleVoteError(error);
                            // Keep dialog open on error so user can try again or cancel
                            // Don't close the modal or reset the flag
                        }
                    } else {
                        self.isVoteDialogOpen = false;
                        modalInstance.close();
                    }
                },
                'cancel': () => {
                    self.isVoteDialogOpen = false;
                    modalInstance.close();
                }
            }
        });
        
        // Also reset flag if modal is closed by other means (ESC, clicking backdrop)
        modalInstance.$on('close', () => {
            self.isVoteDialogOpen = false;
        });
    },
    async deleteLabelVote() {
        if (!this.labelVote) return;

        try {
            this.$dialog.confirm({
                title: 'Remove vote',
                message: 'Are you sure you want to remove your label vote?',
                confirmText: 'Remove vote',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: async () => {
                    const foundBrew = this.contestants.find(brew =>
                        brew.id === this.labelVote.id
                    );

                    if (foundBrew) {
                        const brewClass = this.competition.classes.find(c => c.id === foundBrew.competitionClassId);
                        if (brewClass && brewClass.competitionClassType !== CompetitionClassType.singleVote) {
                            console.error("Brew class found");
                            this.$dialog.alert({
                                title: 'Error',
                                message: 'Failed to find brew class. Please try again.',
                                type: 'is-danger',
                            });
                        }

                        const payload = {
                            brewId: this.labelVote.id,
                            competitionId: this.competitionId,
                            competitionClassId: foundBrew.competitionClassId,
                            voteKey: this.voteKey,
                            keyword: this.keyword
                        };

                        try {
                            await apiService.deleteSingleVote(payload);
                            this.labelVote = null;
                            this.$toast.open({
                                message: 'Vote removed',
                                type: 'is-success',
                                position: 'is-bottom'
                            });
                        } catch (error) {
                            await this.handleVoteError(error);
                        }
                    }
                    else {
                        console.error("Brew not found");
                        this.$dialog.alert({
                            title: 'Error',
                            message: 'Failed to find brew. Please try again.',
                            type: 'is-danger',
                        });
                    }
                }
            });
            
        } catch (error) {
            console.error('Error deleting label vote:', error);
            await this.handleVoteError(error);
        }
    },
},
    computed: {
    brewersChoiceEnabled() {
        return !!(this.competition && this.competition.brewersChoiceVotingEnabled);
    },
    visibleClasses() {
        var self = this;
        return self.competition.classes.filter(c => c.showInList === true) || [];
    },
    labelBrews() {
        // Find the Label class
        const labelClass = this.competition.classes.find(c => c.name === 'Label');
        if (!labelClass) return [];

        // Filter brews by the Label class ID
        return this.contestants
            .filter(brew => brew.competitionClassId === labelClass.id)
            .sort((a, b) => this.sortCompNumberAsc(a.displayNumber, b.displayNumber));
    },
    shuffledLabelBrews() {
        // If not logged in, show in original order
        if (!this.isLoggedIn || !this.voteKey) {
            return this.labelBrews;
        }
        
        return this.shuffleArrayWithSeed(this.labelBrews, this.voteKey);
    },
    computedContestants() {
      var self = this;

      var classesToShow = self.competition.classes.filter(
        c => c.showInList == true
      );

      var onlyForListing = this.contestants.filter(function(i) {
        if (
          classesToShow.some(
            c =>
              c.id === i.competitionClassId ||
              i.competitionClassId == undefined ||
              i.competitionClassId == "" ||
              i.competitionClassId == "00000000-0000-0000-0000-000000000000"
          )
        ) {
          return i;
        }
      });

      var filtered = onlyForListing.filter(function(i) {
          return i;
      });

        var sorted = filtered;
        if (this.sortBy === BeerListSortOrderType.brewName) {
            sorted = filtered.sort(function (a, b) {
                return (
                    self.sortCompStringAsc(a.title, b.title)
                );
            });
        }
        else if (this.sortBy === BeerListSortOrderType.brewNumber) {
            sorted = filtered.sort(function (a, b) {
                return (
                    self.sortCompNumberAsc(a.displayNumber, b.displayNumber)
                );
            });
        }
        else if (this.sortBy === BeerListSortOrderType.brewer) {
            sorted = filtered.sort(function (a, b) {
                return (
                    self.sortCompStringAsc(a.brewer, b.brewer) ||
                    self.sortCompStringDesc(
                        self.getClassLabel(a.competitionClassId),
                        self.getClassLabel(b.competitionClassId)
                    ) ||
                    self.sortCompStringAsc(a.title, b.title)
                );
            });
        }
        else if (this.sortBy === BeerListSortOrderType.myVotes) {
            sorted = filtered.sort(function (a, b) {
                // Get votes for both brews
                const voteA = self.votes[a.id];
                const voteB = self.votes[b.id];

                // If both have votes, sort by vote value descending
                if (voteA !== undefined && voteB !== undefined) {
                    if (voteA !== voteB) {
                        return voteB - voteA; // Higher votes first
                    }
                }
                // If only one has a vote, put the one with vote first
                if (voteA !== undefined && voteB === undefined) return -1;
                if (voteB !== undefined && voteA === undefined) return 1;

                // If neither has votes or votes are equal, use existing sort logic
                return (
                    self.sortCompStringAsc(a.brewer, b.brewer) ||
                    self.sortCompStringDesc(
                        self.getClassLabel(a.competitionClassId),
                        self.getClassLabel(b.competitionClassId)
                    ) ||
                    self.sortCompStringAsc(a.title, b.title)
                );
            });
        }
        else if (this.sortBy === BeerListSortOrderType.abv) {
            sorted = filtered.sort(function (a, b) {
                return (
                    self.sortCompNumberAsc(self.parseAbv(a.abv), self.parseAbv(b.abv)) ||
                    self.sortCompStringDesc(
                        self.getClassLabel(a.competitionClassId),
                        self.getClassLabel(b.competitionClassId)
                    ) ||
                    self.sortCompStringAsc(a.title, b.title)
                );
            });
        }

      return sorted;
      },
        filteredContestants() {
            let filtered;

            if (this.selectedClass === "noclass") {
                filtered = this.computedContestants.filter(
                    brew => brew.competitionClassId === undefined ||
                        brew.competitionClassId === "" ||
                        brew.competitionClassId === "00000000-0000-0000-0000-000000000000"
                );
            }
            else {
                filtered = this.computedContestants.filter(
                    brew => brew.competitionClassId === this.selectedClass
                );

                // Add unvoted filter
                if (this.showUnvotedOnly && this.isLoggedIn) {
                    filtered = filtered.filter(brew => !this.votes[brew.id]);
                }
            }

            return filtered;
        }
        },
};
</script>
<style scoped>
    div.brew-card {
        background: rgba(255, 255, 255, 0.9);
        border: 1px solid #c5c5c5;
        -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
        -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
        -webkit-border-radius: 0px 15px 15px 0px;
        -moz-border-radius: 0px 15px 15px 0px;
        width: 100%; /* 360px !important;*/
        border-radius: 0px 15px 15px 0px;
        display: table;
        overflow: hidden;
        margin-bottom: 10px;
        max-width: 100%;
    }

    .label-list div.brew-card {
        margin-bottom: 30px;
    }

div.active {
    display: none;
    background-color: #ffffff;
}

div.competition-class-black {
    background-color: #494949 !important;
    color: #ffffff;
}

div.competition-class-yellow {
    background-color: #ffdd57;
    color: rgba(0, 0, 0, 0.7);
}
div.competition-class-blue {
    background-color: #167df0;
    color: #ffffff;
}

div.brew-card-header-class {
    border-radius: 0px !important;
    font-size: 0.75rem;
    width: 100%;
    border-left: 1px solid rgba(136, 145, 144, 0.6);
    height: 34px;
    text-align: center;
    vertical-align: middle;
}

div.brew-card-header {
    border-bottom: 1px solid rgba(136, 145, 144, 0.6);
    height: 35px;
    background-color: #f5f5f5;
    vertical-align: middle;
    overflow: auto;
}

.brew-title-container {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0; /* Allow flex items to shrink below content size */
    overflow: hidden;
}

.brew-title-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.brew-number {
    background-color: #494949;
    color: white;
    padding: 2px 6px;
    margin-right: 8px;
    display: inline-block;
    min-width: 28px;
    text-align: center;
    border-radius: 9px;
    font-size: 14px;
    flex-shrink: 0;
}

div.brew-card-header-title {
    padding-top: 5px;
    padding-left: 10px;
}

div.brew-card-footer {
    clear: both;
    border-top: 1px dotted rgba(136, 145, 144, 0.6);
    background-color: #ffffff !important;
    padding: 0px;
    height: auto;
    display: block;
}

.brew-card-footer.disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #f5f5f5 !important;
}

.text-disabled {
    color: #999;
}

.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

div.brew-card-footer-extra-info {
    clear: both;
    text-align: left;
    background-color: #ffffff !important;
    padding: 10px;
    height: auto;
}

div.brew-card-body {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.brew-card-container {
    transition: max-height 0.5s ease-out, margin-bottom 0.5s ease-out, opacity 0.5s ease-out;
    max-height: 1000px;
    margin-bottom: 10px;
    overflow: hidden;
    opacity: 1;
}

.brew-card-container.fade-out {
    max-height: 0;
    margin-bottom: 0;
    opacity: 0;
    overflow: hidden;
}

.alignleft {
  width: 80%;
  float: left;
  text-align: left;
}

.alignright {
  width: 20%;
  float: right;
  text-align: right;
}

.tabTitle {
    font-size: 0.8rem;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.sticky-tabs {
    position: sticky;
    top: 0;
    z-index: 30;
    background: white;
    padding: 10px 0;
    margin: -10px -20px; /* Negative margin to extend background */
    padding-bottom: 5px;
}

/* Add padding to the container to compensate for negative margins */
.sticky-tabs > * {
    padding-left: 20px;
    padding-right: 20px;
}

.tabs.is-boxed {
    margin-bottom: 0px;
}

.control {
    margin-top: 15px;
}

.brew-card:first-of-type {
    margin-top: 20px;
}

.brew-card {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    table-layout: fixed !important;
}

.field.has-addons {
    margin-right: 10px;
}

.input {
    width: 140px;
}

.search-container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.invisible {
    visibility: hidden;
}

.inner-section {
    padding-top: 0.5rem;
}

.button.is-primary {
    background-color: #494949 !important;
    color: #ffffff !important;
    border-color: #494949 !important;
}

.button.is-primary:hover {
    background-color: #3c3c3c !important;
    border-color: #3c3c3c !important;
}

.dropdown-item:hover {
    background-color: #f5f5f5;
}

.dropdown-item.is-active,
.dropdown-item.is-active .media,
.dropdown-item.is-active .media-content h3 {
    background-color: #494949 !important;
    color: #ffffff !important;
}

.login-button-wrapper {
    position: absolute;
    left: 20px;
    top: 22px;
    height: 40px;
    display: flex;
    align-items: center;
}

.label-content {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin-top: 20px;
}

@media screen and (max-width: 400px) {
    .tabs li a {
        padding: 0.25rem 0.4rem;
    }

    /* Used for the No class tab */
    .tabs li:last-child .tabTitle .icon {
        width: 100%;
        text-align: center;
        margin-right: 0;
    }
}

.vote-interface {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dotted rgba(136, 145, 144, 0.6);
    margin-bottom: 10px;
}

.vote-actions-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

.vote-button {
    background-color: #4A90E2;
    color: white;
}

.vote-button:hover {
    background-color: #357ABD;
    color: white;
}

.label-competition {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.label-info-well {
    background-color: #f0f8ff;
    border: 1px solid #d4e6f1;
    border-radius: 6px;
    padding: 12px 16px;
    margin-top: 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    color: #2c5aa0;
    font-size: 14px;
    line-height: 1.5;
}

.label-info-well .icon {
    flex-shrink: 0;
    margin-top: 2px;
}

.label-controls-section {
    width: 100%;
    margin-bottom: 10px;
    margin-top: 1rem;
}

.selected-label-card {
    background: #f5f5f5;
    padding: 1rem;
    border-radius: 4px;
    margin-bottom: 0.5rem;
    border: 2px solid #48c774;
    display: flex;
    flex-direction: column;
}

.label-vote-info {
    width: 100%;
    margin-bottom: 0.5rem;
}

.vote-actions-row {
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

.label-title-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    display: block;
}

.label-brewer-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    display: block;
}

.label-list {
    width: 100%;
}

.label-list .brew-card {
    position: relative;
}

.label-list .brew-title-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.voted-label-card {
    border: 2px solid #48c774;
    box-shadow: 0 4px 8px rgba(72, 199, 116, 0.2);
}

.label-vote-section {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dotted rgba(136, 145, 144, 0.6);
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.voted-indicator {
    display: flex;
    align-items: center;
    gap: 5px;
}

.vote-actions {
    display: flex;
    gap: 8px;
}
div.competition-class-purple {
    background-color: #7957d5 !important;
    color: #ffffff;
}
.invisible {
    display: none !important;
}

.control.is-flex {
    gap: 1rem;
}

.ml-auto {
    margin-left: auto;
}

.unvoted-switch {
    padding-right: 0 !important;
}

.label-vote-btn {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
    height: auto;
    min-width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
}

brew-vote-display {
    flex-shrink: 0;
    display: inline-block;
}

.brewers-choice-toggle {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    margin: 14px 0;
}

@media screen and (max-width: 480px) {
    .brew-card-header {
        height: auto;
        min-height: 35px;
    }
}

/* Modal responsive styles */
.vote-dialog-modal .modal-content {
    margin: 0 10px;
}

/* Mobile mode - full width */
@media screen and (max-width: 768px) {
    .vote-dialog-modal .modal-content {
        margin: 0 !important;
        width: 100vw !important;
        max-width: 100vw !important;
    }
    
    .vote-dialog-modal .modal-card,
    .vote-dialog-modal .animation-content {
        width: 100vw !important;
        max-width: 100vw !important;
        margin: 0 !important;
    }
}

/* Desktop mode - match brew card container width */
@media screen and (min-width: 769px) {
    .vote-dialog-modal .modal-card,
    .vote-dialog-modal .animation-content,
    .vote-dialog-modal .modal-content .modal-card {
        width: 420px !important;
        max-width: 420px !important;
    }
    
    .vote-dialog-modal .modal-content {
        width: auto !important;
        max-width: none !important;
    }
}

@media screen and (max-width: 375px) {
    .vote-dialog-modal .modal-content {
        margin: 0 !important;
        width: 100vw !important;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .vote-dialog-modal .animation-content,
    .vote-dialog-modal .modal-card {
        width: 100vw !important;
        max-width: 100vw !important;
        max-height: 100vh;
        overflow: hidden;
        margin: 0 !important;
    }
}
</style>